module.exports = __webpack_public_path__ + "static/media/comment-alt-smile.9140d767.svg";